import AgentActiveDot, {
  type DotVariants,
} from '@components/AgentAvatar/AgentActiveDot';
import { Box } from '@components/Box';
import { getAvatarUrl, isAvatarValid } from '@utils/agentAvatar';
import type { ComponentPropsWithoutRef } from 'react';
import { Avatar } from './Avatar';
import { cn } from '@utils/cn';

export const DEFAULT_AVATAR = getAvatarUrl('avatar_1');

export type AgentAvatarProps = ComponentPropsWithoutRef<'img'>;

export const AgentAvatar = ({
  src,
  alt = 'Agent avatar',
  ...props
}: AgentAvatarProps) => {
  const computedSrc = isAvatarValid(src) ? getAvatarUrl(src) : src;

  return (
    <Avatar src={[computedSrc ?? '', DEFAULT_AVATAR]} alt={alt} {...props} />
  );
};

export type AgentAvatarWithStatusProps = AgentAvatarProps & {
  status?: boolean;
  dotSize?: DotVariants['size'];
};

export const AgentAvatarWithStatus = ({
  status = false,
  dotSize,
  className,
  ...props
}: AgentAvatarWithStatusProps) => {
  return (
    <Box className="relative">
      <AgentAvatar
        className={cn(
          'rounded-[20%] [mask-image:radial-gradient(circle_at_calc(100%-1px)_calc(100%-1px),transparent_22%,black_0)]',
          {
            '[mask-image:radial-gradient(circle_at_calc(100%-2px)_calc(100%-0.5px),transparent_14%,black_0)]':
              dotSize === 'md',
          },
          className,
        )}
        {...props}
      />
      <AgentActiveDot variant={status ? 'active' : 'inactive'} size={dotSize} />
    </Box>
  );
};
